import { IChat } from '../../types/Chat/IChat';
import { IChatMessage } from '../../types/Chat/IChatMessage';
import { Api } from './BaseApi'

const ChatApi = Api.injectEndpoints({
    endpoints: (build) => ({
        // getChats: build.query<IChat[], void>({
        //     query: (UId) => `Chat`,
        //     providesTags: ["Chat"],
        // }),
        getChat: build.query<IChat, string>({
            query: (UId) => `Chat/${UId}`,
            providesTags: ["Chat"],
        }),
        getMessages: build.query<IChatMessage[], string>({
            query: (UId) => `Chat/${UId}/Message`,
            providesTags: ["ChatMessages"],
        }),

    }),
})


export { ChatApi };